import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-16"
}
const _hoisted_2 = {
  key: 1,
  class: "mb-16"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-32" }, " You are about to approve the following asset: ", -1 /* HOISTED */)
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "mb-32" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " The Boundary will be notified and move to Stage B. ", -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["SimpleModalComponent"], {
    heading: $setup.heading,
    onCloseModal: _cache[1] || (_cache[1] = $event => ($setup.emit( 'close-modal' )))
  }, {
    content: _withCtx(() => [
      ($setup.type_is_staff)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, " You are about to approve this upload and make it visible to the client. "))
        : ($setup.type_is_client && $setup.approval_is_final)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, " You are about to approve this stage as the final asset. The asset and all its comment threads will be locked and you will be able to download the high-res version(s) of it. "))
          : ($setup.type_is_client)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _hoisted_3,
                ($props.option.thumbnail_url || $props.option.image_small_url)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "approval-thumbnail-image",
                      src: $props.option.thumbnail_url || $props.option.image_small_url,
                      alt: $props.option.title
                    }, null, 8 /* PROPS */, _hoisted_4))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("p", _hoisted_5, _toDisplayString($props.option.title), 1 /* TEXT */),
                _hoisted_6
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("button", {
        class: "button",
        onClick: _cache[0] || (_cache[0] = $event => ($setup.emit( 'close-modal' )))
      }, " Cancel "),
      _createElementVNode("button", {
        class: "button button--fill",
        onClick: $setup.emitApproval
      }, " Approve ")
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["heading"]))
}